import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import Switch from 'react-switch';

import { ToggleContainer, FormLabel } from './css';
import request from '../../../../../utils/request';

const FormBlock = ({ data }) => {
  const { label, formFreezeId } = data;

  const [isEnabled, setIsEnabled] = useState(false);

  const toggleFormAccess = async () => {
    try {
      request.post(`/options/${formFreezeId}`, {
        value: isEnabled ? 1 : 0
      });
      setIsEnabled(!isEnabled);
    } catch (err) {
      throw err;
    }
  };

  const fetchFormSetting = async () => {
    const result = await request.get(`/options/${formFreezeId}`);

    if (result && result.status === 200)
      setIsEnabled(_.get(result, 'data.value', '0') === '0');
  };

  useEffect(() => {
    fetchFormSetting();
  }, []);

  return (
    <ToggleContainer isEnabled={isEnabled}>
      <FormLabel isEnabled={isEnabled}>{label}</FormLabel>
      <Switch
        onColor="#4B286D"
        onChange={toggleFormAccess}
        checked={isEnabled}
      />
    </ToggleContainer>
  );
};

FormBlock.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    formFreezeId: PropTypes.number
  }).isRequired
};

export default FormBlock;
